import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { catchError, of, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import {
  Conditions,
  Departments,
  deptpriceconfig,
  StoreGroupModel,
} from '../../../../Models/ApplicationModels';
import { MasterDataSeriveService } from '../../../../Services/master-data-serive.service';
import { ExportExcelService } from '../../../../Services/export-excel.service';
import { AdminBreadcrumbsService } from '../../admin-services/admin-breadcrumbs.service';

import { Status } from 'src/app/enum/enum';
import * as XLSX from 'xlsx';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-pricing-config',
  templateUrl: './pricing-config.component.html',
  styleUrls: ['./pricing-config.component.css'],
})
export class PricingConfigComponent {
  @ViewChild('customSelect', { static: false }) customSelect!: ElementRef;
  Deptpriceconfigarray: Array<deptpriceconfig> = [];
  Deptpriceconfigarray1: Array<deptpriceconfig> = [];
  DeptpriceconfigarrayforDepartment: Array<deptpriceconfig> = [];
  DeptpriceconfigarrayforCategory: Array<deptpriceconfig> = [];
  DeptpriceconfigarrayforpricingTypeID: Array<deptpriceconfig> = [];
  DeptpriceconfigarrayforFilters: Array<deptpriceconfig> = [];
  DeptpriceconfigarrayforQuality: Array<deptpriceconfig> = [];
  DeptpriceconfigarrayforstoreGroup: Array<deptpriceconfig> = [];
  Deptpriceconfigarrayforcondition: Array<deptpriceconfig> = [];
  Deptpriceconfigarrayforcompany: Array<deptpriceconfig> = [];
  unaddedPrices: Array<deptpriceconfig> = [];
  priceconfig: deptpriceconfig = new deptpriceconfig();
  departmentslist: Array<Departments> = [];
  filterName: string = 'Department';
  filterCategoriesIDs: number[] = [];
  filterConfigIDs: number[] = [];
  QualityConfigIDs: number[] = [];
  storeGroupIDs: number[] = [];
  conditionIDs: number[] = [];
  filterDepartmentIDs: number[] = [];
  filtercompanyID: number[] = [];
  noData: boolean = false;
  isFilterModalOpen: boolean = false;
  storeGroups: Array<StoreGroupModel> = [];
  selectedStoregrp: number = 0;
  selectedStoreName: string = '';
  clickedDepts: number[] = [];
  sendDataForPriceConfig: Array<Departments> = [];
  editZone: boolean = false;
  selectedRowIndex: number | null = null;
  departmentName: string = '';
  storeGroupName: string = '';
  categoryName: string = '';
  subCategoryName: string = '';
  showCategoryName: boolean = true;
  showSubCategoryName: boolean = true;
  priceConfigTypeID: number = 0;
  storeGroupId: number = 0;
  openInput: boolean = false;
  DeptpriceUpdate: Array<deptpriceconfig> = [];
  arrayForEditPriceConfig: Array<deptpriceconfig> = [];
  tempArray: Array<deptpriceconfig> = [];
  modifiedPriceIDs: Set<number> = new Set();
  isUpdating: boolean = false;
  deletePrices: string[] = [];
  checkDel: boolean = true;
  selectedDeptForFiletr: any[] = [];
  storeReset: any[] = [];
  departmentReset: any[] = [];
  isCustomSelect: boolean = true;
  resetStoreID: number = 0;
  priceobj = new deptpriceconfig();
  priceConfigPostDataString: string[] = [];
  pricingTypeID!: number;
  lastPrice: any;
  prcingTypeConfigData: any;
  sortVals: boolean = false;
  isPriceActive: boolean = true;
  isFilterApplied: boolean = false;
  departmentIDs: number[] = [];
  selectedIds: string = '';
  pricingConfig: Array<deptpriceconfig> = [];
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('importModal') importModal!: ElementRef<HTMLElement>;
  @ViewChild('importModalClose')
  importModalClose!: ElementRef<HTMLButtonElement>;
  importData: any[] = [];
  importPreview: any[] = [];
  importErrors: string[] = [];
  validImportRows: number = 0;
  isImporting: boolean = false;
  conditions: Conditions[] = [];
  validationCache: Map<string, any> = new Map();
  isImportLoading: boolean = false;
  isLoading: boolean = false;
  private routerSubscription?: Subscription;

  pricingTypeMapping: { [key: string]: number } = {
    'GBB by Category and SubCategory': 1,
    'Price Lists by Category and SubCategory': 2,
    'Price Lists by Department': 3,
    'Quality and Condition by Category and SubCategory': 4,
    'GBB by Department': 5,
    'Quality and Condition by Department': 6,
  };

  constructor(
    private masterservice: MasterDataSeriveService,
    private datepipe: DatePipe,
    private adminBreadcrumbs: AdminBreadcrumbsService,
    private toastr: ToastrService,
    private excelExport: ExportExcelService,
    private router: Router
  ) { }

  async ngOnInit() {
    this.adminBreadcrumbs.updateBreadcrumbs([
      { crumbName: 'Company Config', link: 'demo' },
      { crumbName: 'Pricing', link: '/admin/home/pricing/pricing-config' },
    ]);

    await this.getAllStoreGroup();
    this.getAllPricingConfigs();
    this.getAllDepartments();
    this.getAllConditions();
    this.isUpdating = false;
  }

  async getUnaddedPrices() {
    this.isLoading = true;

    try {
      const user = this.masterservice.getUserDetailsFromStorage();

      const res: any = await this.masterservice
        .checkunaddedPrices(user.companyID)
        .pipe(
          catchError((error) => {
            console.error('Error fetching unadded prices:', error);
            this.unaddedPrices = [];
            return of([]);
          })
        )
        .toPromise();

      if (res) {
        let pricingData = res as deptpriceconfig[];

        pricingData.forEach((item) => {
          const matchedGroup = this.storeGroups.find(
            (group) => group.id === item.storeGroupId
          );
          if (matchedGroup) {
            item.name = matchedGroup.name;
          }
        });

        this.unaddedPrices = pricingData;
        this.Deptpriceconfigarray = pricingData;
        this.Deptpriceconfigarray1 = pricingData;
        this.DeptpriceUpdate = pricingData;

        this.getseparatedataforFilters();
      }
    } catch (error) {
      console.error('Error in getUnaddedPrices:', error);
    } finally {
      this.isLoading = false; // loader always stops
    }
  }

  showUpdated() {
    this.toastr.success('Prices Updated !', 'Success');
  }

  async getAllPricingConfigs() {
    this.isLoading = true;

    try {
      let userdata = this.masterservice.getUserDetailsFromStorage();
      let c_id = userdata.companyID;

      const res: any = await this.masterservice
        .getPricingTypeConfig(c_id)
        .toPromise();

      if (res) {
        let pricingData = res as deptpriceconfig[];
        pricingData.forEach((item) => {
          const matchedGroup = this.storeGroups.find(
            (group) => group.id === item.storeGroupId
          );
          if (matchedGroup) {
            item.name = matchedGroup.name;
          }
        });

        this.pricingConfig = pricingData;
        this.Deptpriceconfigarray = pricingData;
        this.Deptpriceconfigarray1 = pricingData;
        this.DeptpriceUpdate = pricingData;

        this.getseparatedataforFilters();

        this.Deptpriceconfigarray.forEach((res) => {
          res.expirationDt = this.masterservice.removeTimeFromDate(
            res.expirationDt
          );
          res.effectiveDt = this.masterservice.removeTimeFromDate(
            res.effectiveDt
          );
        });
      }
    } catch (error) {
      console.error('Error loading pricing configs:', error);
    } finally {
      this.isLoading = false;
    }
  }

  emptyform() {
    this.priceconfig = new deptpriceconfig();
  }

  getseparatedataforFilters() {
    this.DeptpriceconfigarrayforDepartment = this.Deptpriceconfigarray1;
    this.DeptpriceconfigarrayforCategory = this.Deptpriceconfigarray1;
    this.DeptpriceconfigarrayforpricingTypeID = this.Deptpriceconfigarray1;
    this.DeptpriceconfigarrayforFilters = this.Deptpriceconfigarray1;
    this.DeptpriceconfigarrayforQuality = this.Deptpriceconfigarray1;
    this.DeptpriceconfigarrayforstoreGroup = this.Deptpriceconfigarray1;
    this.Deptpriceconfigarrayforcondition = this.Deptpriceconfigarray1;
    this.Deptpriceconfigarrayforcompany = this.Deptpriceconfigarray1;

    var filterArray = this.DeptpriceconfigarrayforDepartment.reduce(
      (accumulator: any, current) => {
        if (
          !accumulator.some(
            (item: any) => item.departmentId === current.departmentId
          )
        ) {
          current.isSelected = false;
          accumulator.push(current);
        }
        return accumulator;
      },
      []
    );
    this.DeptpriceconfigarrayforFilters = filterArray;
    this.DeptpriceconfigarrayforDepartment = filterArray;
    this.departmentReset = filterArray;

    var filterArray1 = this.DeptpriceconfigarrayforCategory.reduce(
      (accumulator: any, current) => {
        if (
          !accumulator.some(
            (item: any) => item.categoryId === current.categoryId
          )
        ) {
          current.cIsSelected = false;
          accumulator.push(current);
        }
        return accumulator;
      },
      []
    );
    filterArray1.sort((a: { categoryName: string }, b: { categoryName: any }) =>
      a.categoryName.localeCompare(b.categoryName)
    );

    this.DeptpriceconfigarrayforCategory = filterArray1;

    var filterArray2 = this.DeptpriceconfigarrayforpricingTypeID.reduce(
      (accumulator: any, current) => {
        if (
          !accumulator.some(
            (item: any) => item.pricingTypeId === current.pricingTypeId
          )
        ) {
          current.configSelected = false;
          accumulator.push(current);
        }
        return accumulator;
      },
      []
    );

    this.DeptpriceconfigarrayforpricingTypeID = filterArray2;

    var filterArray3 = this.DeptpriceconfigarrayforQuality.reduce(
      (accumulator: any, current) => {
        if (
          !accumulator.some((item: any) => item.qualityId === current.qualityId)
        ) {
          current.qualityName = current.qualityDescr;
          if (current.qualityId == 0) {
            current.qualityName = 'No Qualities';
          }
          current.qualitySelected = false;
          accumulator.push(current);
        }
        return accumulator;
      },
      []
    );
    this.DeptpriceconfigarrayforQuality = filterArray3;

    var filterArray4 = this.DeptpriceconfigarrayforstoreGroup.reduce(
      (accumulator: any, current) => {
        if (
          !accumulator.some(
            (item: any) => item.storeGroupId === current.storeGroupId
          )
        ) {
          current.storeGroupIdSelected = false;
          accumulator.push(current);
        }
        return accumulator;
      },
      []
    );
    this.DeptpriceconfigarrayforstoreGroup = filterArray4;
    this.storeReset = filterArray4;
    var filterArray5 = this.Deptpriceconfigarrayforcondition.reduce(
      (accumulator: any, current) => {
        if (
          !accumulator.some(
            (item: any) => item.conditionId === current.conditionId
          )
        ) {
          current.conditionName = current.conditionDescr;
          current.qualitySelected = false;
          if (current.conditionId == 0) {
            current.conditionName = 'No conditions';
          }
          accumulator.push(current);
        }
        return accumulator;
      },
      []
    );
    this.Deptpriceconfigarrayforcondition = filterArray5;

    var filterArray5 = this.Deptpriceconfigarrayforcompany.reduce(
      (accumulator: any, current) => {
        if (
          !accumulator.some((item: any) => item.companyId === current.companyId)
        ) {
          current.companyIdSelected = false;
          accumulator.push(current);
        }
        return accumulator;
      },
      []
    );
    this.Deptpriceconfigarrayforcompany = filterArray5;
  }

  collectFilterParameters(search: any) {
    this.DeptpriceconfigarrayforFilters.forEach((elements: deptpriceconfig) => {
      if (this.filterName === 'Department' && elements.departmentId == search) {
        elements.isSelected = !elements.isSelected;
        if (elements.isSelected) {
          this.selectedDeptForFiletr.push(search);
        } else {
          this.selectedDeptForFiletr = this.selectedDeptForFiletr.filter(
            (item) => item != search
          );
        }
      } else if (
        this.filterName === 'Category' &&
        elements.categoryId == search
      ) {
        elements.cIsSelected = !elements.cIsSelected;
      } else if (
        this.filterName === 'Config' &&
        elements.pricingTypeId == search
      ) {
        elements.configSelected = !elements.configSelected;
      } else if (
        this.filterName === 'Quality' &&
        elements.qualityId == search
      ) {
        elements.qualitySelected = !elements.qualitySelected;
      } else if (
        this.filterName === 'Store' &&
        elements.storeGroupId == search
      ) {
        elements.storeGroupIdSelected = !elements.storeGroupIdSelected;
      } else if (
        this.filterName === 'Condition' &&
        elements.conditionId == search
      ) {
        elements.conditionIdSelected = !elements.conditionIdSelected;
      } else if (
        this.filterName === 'Company' &&
        elements.companyId == search
      ) {
        elements.companyIdSelected = !elements.companyIdSelected;
      }
    });

    if (this.filterName === 'Department') {
      this.toggleFilterParameter(this.filterDepartmentIDs, search);
    } else if (this.filterName === 'Category') {
      this.toggleFilterParameter(this.filterCategoriesIDs, search);
    } else if (this.filterName === 'Config') {
      this.toggleFilterParameter(this.filterConfigIDs, search);
    } else if (this.filterName === 'Quality') {
      this.toggleFilterParameter(this.QualityConfigIDs, search);
    } else if (this.filterName === 'Store') {
      this.toggleFilterParameter(this.storeGroupIDs, search);
      // Refresh department options if store selection changed
      this.refreshDeptFilterBasedOnStoreSelection();
    } else if (this.filterName === 'Condition') {
      this.toggleFilterParameter(this.conditionIDs, search);
    } else if (this.filterName === 'Company') {
      this.toggleFilterParameter(this.filtercompanyID, search);
    }
  }

  toggleFilterParameter(filterArray: any[], search: any) {
    const index = filterArray.indexOf(search);
    if (index !== -1) {
      filterArray.splice(index, 1);
    } else {
      filterArray.push(search);
    }
  }

  getFilterData() {
    if (
      this.filterDepartmentIDs.length > 0 ||
      this.filterCategoriesIDs.length > 0 ||
      this.filterConfigIDs.length > 0 ||
      this.QualityConfigIDs.length > 0 ||
      this.storeGroupIDs.length > 0 ||
      this.conditionIDs.length > 0
    ) {
      this.isFilterApplied = true;
    }

    const filteredArray = this.Deptpriceconfigarray1.filter((item) => {
      const deptFilter =
        this.filterDepartmentIDs.length === 0 ||
        this.filterDepartmentIDs.includes(item.departmentId);
      const categoryFilter =
        this.filterCategoriesIDs.length === 0 ||
        this.filterCategoriesIDs.includes(item.categoryId);
      const configFilter =
        this.filterConfigIDs.length === 0 ||
        this.filterConfigIDs.includes(item.pricingTypeId);
      const QualityFilter =
        this.QualityConfigIDs.length === 0 ||
        this.QualityConfigIDs.includes(item.qualityId);
      const storeGroupIDFilter =
        this.storeGroupIDs.length === 0 ||
        this.storeGroupIDs.includes(item.storeGroupId);
      const conditionIDFilter =
        this.conditionIDs.length === 0 ||
        this.conditionIDs.includes(item.conditionId);
      const companyIDFilter =
        this.filtercompanyID.length === 0 ||
        this.filtercompanyID.includes(item.companyId);
      return (
        deptFilter &&
        categoryFilter &&
        configFilter &&
        QualityFilter &&
        storeGroupIDFilter &&
        conditionIDFilter &&
        companyIDFilter
      );
    });

    if (
      this.filterDepartmentIDs.length === 0 &&
      this.filterCategoriesIDs.length === 0 &&
      this.filterConfigIDs.length === 0 &&
      this.QualityConfigIDs.length === 0 &&
      this.storeGroupIDs.length === 0 &&
      this.conditionIDs.length === 0
    ) {
      this.Deptpriceconfigarray = filteredArray.length
        ? filteredArray
        : this.Deptpriceconfigarray1;
      this.noData = false;
    } else if (filteredArray.length == 0) {
      this.Deptpriceconfigarray = filteredArray;
      this.noData = true;
    } else {
      this.Deptpriceconfigarray = filteredArray;
    }
  }

  selectedFilterCategory(dta: any) {
    this.filterName = dta;
    if (dta == 'Department') {
      // Refresh department options based on selected store groups
      this.refreshDeptFilterBasedOnStoreSelection();
    } else if (dta == 'Category') {
      this.DeptpriceconfigarrayforFilters =
        this.DeptpriceconfigarrayforCategory;
      if (this.selectedDeptForFiletr.length) {
        this.DeptpriceconfigarrayforFilters =
          this.DeptpriceconfigarrayforFilters.filter((item) =>
            this.selectedDeptForFiletr.includes(item.departmentId)
          );
      }
    } else if (dta == 'Config') {
      this.DeptpriceconfigarrayforFilters =
        this.DeptpriceconfigarrayforpricingTypeID;
    } else if (dta == 'Quality') {
      this.DeptpriceconfigarrayforFilters = this.DeptpriceconfigarrayforQuality;
    } else if (dta == 'Store') {
      this.DeptpriceconfigarrayforFilters =
        this.DeptpriceconfigarrayforstoreGroup;
    } else if (dta == 'Condition') {
      this.DeptpriceconfigarrayforFilters =
        this.Deptpriceconfigarrayforcondition;
    } else if (dta == 'Company') {
      this.DeptpriceconfigarrayforFilters = this.Deptpriceconfigarrayforcompany;
    }
  }

  refreshDeptFilterBasedOnStoreSelection() {
    if (this.storeGroupIDs && this.storeGroupIDs.length > 0) {
      const deptsForStores: any[] = [];
      this.Deptpriceconfigarray1.forEach((item: any) => {
        if (this.storeGroupIDs.includes(item.storeGroupId)) {
          if (!deptsForStores.some((d) => d.departmentId === item.departmentId)) {
            const copy = { ...item };
            copy.isSelected = false;
            deptsForStores.push(copy);
          }
        }
      });
      // Update department list (do not overwrite generic filters array)
      this.DeptpriceconfigarrayforDepartment = deptsForStores;
      // If the Department filter is currently active, update the visible list
      if (this.filterName === 'Department') {
        this.DeptpriceconfigarrayforFilters = deptsForStores;
      }
    } else {
      // Restore the original department list
      this.DeptpriceconfigarrayforDepartment = this.departmentReset;
      if (this.filterName === 'Department') {
        this.DeptpriceconfigarrayforFilters = this.DeptpriceconfigarrayforDepartment;
      }
    }
  }

  openFilterModal(modalState: string) {
    if (modalState === 'Open') {
      this.isFilterModalOpen = true;
    }

    if (modalState === 'Close') {
      this.isFilterModalOpen = false;

      // Clear all filter id arrays
      this.filterDepartmentIDs = [];
      this.filterCategoriesIDs = [];
      this.filterConfigIDs = [];
      this.QualityConfigIDs = [];
      this.storeGroupIDs = [];
      this.conditionIDs = [];
      this.filtercompanyID = [];

      // Reset selection flags on the filter arrays
      (this.DeptpriceconfigarrayforFilters || []).forEach((el: any) => {
        el.isSelected = false;
        el.cIsSelected = false;
        el.configSelected = false;
        el.qualitySelected = false;
        el.storeGroupIdSelected = false;
        el.conditionIdSelected = false;
        el.companyIdSelected = false;
      });
    }
  }

  clearFilter(dta: any) {
    this.isFilterApplied = false;
    if (dta == 'Department') {
      this.filterDepartmentIDs = [];
      this.DeptpriceconfigarrayforFilters.forEach((el) => {
        el.isSelected = false;
      });
      this.selectedDeptForFiletr = [];
      this.selectedFilterCategory(dta);
    } else if (dta == 'Category') {
      this.filterCategoriesIDs = [];
      this.DeptpriceconfigarrayforFilters.forEach((el) => {
        el.cIsSelected = false;
      });
      this.selectedDeptForFiletr = [];
      this.selectedFilterCategory(dta);
    } else if (dta == 'Config') {
      this.filterConfigIDs = [];
      this.DeptpriceconfigarrayforFilters.forEach((el) => {
        el.configSelected = false;
      });
    } else if (dta == 'Quality') {
      this.QualityConfigIDs = [];
      this.DeptpriceconfigarrayforFilters.forEach((el) => {
        el.qualitySelected = false;
      });
    } else if (dta == 'Store') {
      this.storeGroupIDs = [];
      this.DeptpriceconfigarrayforFilters.forEach((el) => {
        el.storeGroupIdSelected = false;
      });
      // If currently viewing Department filter, refresh department list to show all
      if (this.filterName === 'Department') {
        this.selectedFilterCategory('Department');
      }
    } else if (dta == 'Condition') {
      this.conditionIDs = [];
      this.DeptpriceconfigarrayforFilters.forEach((el) => {
        el.conditionIdSelected = false;
      });
    } else if (dta == 'Company') {
      this.Deptpriceconfigarrayforcompany = [];
      this.DeptpriceconfigarrayforFilters.forEach((el) => {
        el.companyIdSelected = false;
      });
    }
    this.noData = false;

    this.getFilterData();
  }
  clearAllFilter() {
    this.filterDepartmentIDs = [];
    this.DeptpriceconfigarrayforFilters.forEach((el) => {
      el.isSelected = false;
    });
    this.filterCategoriesIDs = [];
    this.DeptpriceconfigarrayforFilters.forEach((el) => {
      el.cIsSelected = false;
    });
    this.filterConfigIDs = [];
    this.DeptpriceconfigarrayforFilters.forEach((el) => {
      el.configSelected = false;
    });

    this.QualityConfigIDs = [];
    this.DeptpriceconfigarrayforFilters.forEach((el) => {
      el.qualitySelected = false;
    });

    this.storeGroupIDs = [];
    this.DeptpriceconfigarrayforFilters.forEach((el) => {
      el.storeGroupIdSelected = false;
    });
    this.conditionIDs = [];
    this.DeptpriceconfigarrayforFilters.forEach((el) => {
      el.conditionIdSelected = false;
    });
    this.Deptpriceconfigarrayforcompany = [];
    this.DeptpriceconfigarrayforFilters.forEach((el) => {
      el.companyIdSelected = false;
    });
    this.noData = false;

    this.getFilterData();
  }

  private async getAllStoreGroup(): Promise<void> {
    return new Promise((resolve, reject) => {
      const userdata = this.masterservice.getUserDetailsFromStorage();

      this.masterservice.getStoreGroupsCompany(userdata.companyID).subscribe({
        next: (res) => {
          this.storeGroups = (res as StoreGroupModel[]).filter(
            (item) => item.status === Status.Active
          );

          if (this.storeGroups.length > 0) {
            this.selectedStoregrp = this.storeGroups[0].id;
          }
          resolve();
        },
        error: (error) => {
          console.error('Error fetching store groups:', error);
          reject(error);
        },
      });
    });
  }

  sortValues(val: any) {
    switch (val) {
      case 'storeGrp':
        this.sortVals = !this.sortVals;
        if (this.sortVals) {
          this.Deptpriceconfigarray.sort((a, b) =>
            (a.name || '').localeCompare(b.name || '')
          );
          this.unaddedPrices.sort((a, b) =>
            (a.name || '').localeCompare(b.name || '')
          );
        } else {
          this.Deptpriceconfigarray.sort((a, b) =>
            (b.name || '').localeCompare(a.name || '')
          );
          this.unaddedPrices.sort((a, b) =>
            (b.name || '').localeCompare(a.name || '')
          );
        }
        break;

      case 'deptDesc':
        this.sortVals = !this.sortVals;
        if (this.sortVals) {
          this.Deptpriceconfigarray.sort((a, b) =>
            a.department.localeCompare(b.department)
          );
          this.unaddedPrices.sort((a, b) =>
            a.department.localeCompare(b.department)
          );
        } else {
          this.Deptpriceconfigarray.sort((a, b) =>
            b.department.localeCompare(a.department)
          );
          this.unaddedPrices.sort((a, b) =>
            b.department.localeCompare(a.department)
          );
        }
        break;

      case 'ctgName':
        this.sortVals = !this.sortVals;
        if (this.sortVals) {
          this.Deptpriceconfigarray.sort((a, b) =>
            a.categoryName.localeCompare(b.categoryName)
          );
          this.unaddedPrices.sort((a, b) =>
            a.categoryName.localeCompare(b.categoryName)
          );
        } else {
          this.Deptpriceconfigarray.sort((a, b) =>
            b.categoryName.localeCompare(a.categoryName)
          );
          this.unaddedPrices.sort((a, b) =>
            b.categoryName.localeCompare(a.categoryName)
          );
        }
        break;
      case 'subCtgName':
        this.sortVals = !this.sortVals;

        if (this.sortVals) {
          this.Deptpriceconfigarray.sort((a, b) =>
            (a.subCategoryName || '').localeCompare(b.subCategoryName || '')
          );
          this.unaddedPrices.sort((a, b) =>
            (a.subCategoryName || '').localeCompare(b.subCategoryName || '')
          );
        } else {
          this.Deptpriceconfigarray.sort((a, b) =>
            (b.subCategoryName || '').localeCompare(a.subCategoryName || '')
          );
          this.unaddedPrices.sort((a, b) =>
            (b.subCategoryName || '').localeCompare(a.subCategoryName || '')
          );
        }
        break;
    }
  }

  toggleStoreGroups(index: number) {
    this.selectedStoregrp = index;
  }

  getAllDepartments() {
    this.masterservice.getMainDepartments().subscribe((res: any) => {
      this.departmentslist = res as Departments[];
      this.departmentslist = this.departmentslist.filter(
        (department) => department.active === true
      );
      this.clickedDepts = [];
      this.departmentslist.map((res) => {
        this.clickedDepts.push(res.departmentId);
      });
    });
  }

  toggleSelect(event: any) {
    if (event.target.checked) {
      this.departmentslist.forEach((res) => {
        res.active = true;
        if (!this.clickedDepts.includes(res.departmentId)) {
          this.clickedDepts.push(res.departmentId);
        }
      });
    } else {
      this.departmentslist.forEach((res) => {
        res.active = false;
        this.clickedDepts = [];
      });
    }
  }

  getSelectedDepartment(deptId: number) {
    const department = this.departmentslist.find(
      (dept) => dept.departmentId === deptId
    );
    if (department) {
      if (this.clickedDepts.includes(department.departmentId)) {
        this.clickedDepts = this.clickedDepts.filter(
          (item) => item != department.departmentId
        );
      } else {
        this.clickedDepts.push(department.departmentId);
      }
      department.active = !department.active;
    }
  }

  sendData(config: any) {
    // Create a new object with camelCase properties
    const configData = {
      ...config,
      storeGroupId: this.selectedStoregrp,
      departmentId: config.departmentId,
      pricingTypeId: 0,
      storeGroupName: config.name || this.selectedStoreName,
      categoryId: config.categoryId,
      subCategoryId: config.subCategoryId,
    };
    this.sendDataForPriceConfig.push(configData);
    localStorage.setItem(
      'pricing',
      JSON.stringify(this.sendDataForPriceConfig)
    );

    this.masterservice.dataForPriceConfig = this.sendDataForPriceConfig;
  }

  async dataForPricingConfig(id: number) {
    localStorage.removeItem('pricing');
    let storeData: any = this.storeGroups.find(
      (obj) => obj.id == this.selectedStoregrp
    );
    this.selectedStoreName = storeData.name;

    for (const deptId of this.clickedDepts) {
      try {
        const res: any = await this.masterservice
          .getDepartmentById(deptId)
          .toPromise();
        let departmentData = res as Departments;
        // Create object with camelCase properties
        const deptConfig = {
          ...departmentData,
          storeGroupId: this.selectedStoregrp,
          storeGroupName: this.selectedStoreName,
          pricingTypeId: 0,
        };
        this.sendDataForPriceConfig.push(deptConfig);
      } catch (error) {
        console.error('Error fetching department data:', error);
      }
    }

    localStorage.setItem(
      'pricing',
      JSON.stringify(this.sendDataForPriceConfig)
    );

    this.masterservice.dataForPriceConfig = this.sendDataForPriceConfig;
    window.location.reload();
  }

  truncateDecimals(number: number, digits = 2) {
    const factor = Math.pow(10, digits);
    return Math.floor(number * factor) / factor;
  }

  updatePrice(price: deptpriceconfig) {
    price.price = this.truncateDecimals(price.price, 2);
    this.masterservice.updatePriceConfig(price).subscribe((res) => {
      if (res) {
        this.selectedRowIndex = null;
        this.editZone = true;
        this.openInput = true;
      }
    });
  }

  getPricingConfigByID(configdata: any) {
    this.priceobj = { ...configdata };
    this.isUpdating = true;

    this.arrayForEditPriceConfig.length = 0;
    this.modifiedPriceIDs.clear();

    this.priceconfig = configdata;
    this.storeGroupName = this.priceconfig.name;
    this.departmentName = this.priceconfig.department;
    this.categoryName = this.priceconfig.categoryName;
    this.priceConfigTypeID = this.priceconfig.pricingTypeId;
    this.storeGroupId = this.priceconfig.storeGroupId;
    if (
      this.priceConfigTypeID == 3 ||
      this.priceConfigTypeID == 5 ||
      this.priceConfigTypeID == 6
    ) {
      this.showCategoryName = false;
    } else {
      this.showCategoryName = true;
    }

    //Getting data for update price config
    let subCategoryID = configdata.subCategoryId;
    if (subCategoryID > 0) {
      this.showSubCategoryName = true;
      this.subCategoryName = configdata.subCategoryName;
      this.Deptpriceconfigarray.forEach((data) => {
        if (
          this.priceconfig.categoryId == data.categoryId &&
          this.priceConfigTypeID == data.pricingTypeId &&
          this.storeGroupId == data.storeGroupId &&
          this.priceconfig.subCategoryId == data.subCategoryId
        ) {
          // push a copy so edits don't mutate the original list
          this.arrayForEditPriceConfig.push({ ...data });
        }
      });
    } else {
      this.showSubCategoryName = false;
      this.Deptpriceconfigarray.forEach((data) => {
        if (
          this.priceconfig.categoryId == data.categoryId &&
          this.priceConfigTypeID == data.pricingTypeId &&
          this.storeGroupId == data.storeGroupId
        ) {
          // push a copy so edits don't mutate the original list
          this.arrayForEditPriceConfig.push({ ...data });
        }
      });
    }

    this.priceconfig.effectiveDt = this.datepipe.transform(
      this.priceconfig.effectiveDt,
      'yyyy-MM-dd'
    );
    this.priceconfig.expirationDt = this.datepipe.transform(
      this.priceconfig.expirationDt,
      'yyyy-MM-dd'
    );

    this.editZone = false;
    this.selectedRowIndex = null;
    // store a deep copy snapshot for cancel/reset (so later mutations don't affect the snapshot)
    this.tempArray = this.arrayForEditPriceConfig.map((item) => ({ ...item }));
  }

  editPriceConfig(index: any) {
    this.lastPrice = this.Deptpriceconfigarray[index].price;
    this.selectedRowIndex = index;
    this.editZone = true;
    this.openInput = true;
  }

  savedata() {
    if (this.selectedIds != '') {
      this.masterservice
        .deletePricingConfig(this.selectedIds)
        .subscribe((res) => {
          if (res) {
            this.arrayForEditPriceConfig = this.arrayForEditPriceConfig.filter(
              (item) => !this.selectedIds.includes(item.priceId.toString())
            );
            this.Deptpriceconfigarray = this.Deptpriceconfigarray.filter(
              (item) => !this.selectedIds.includes(item.priceId.toString())
            );
            this.selectedIds = '';
            this.deletePrices = [];
          }
        });
    }

    // Only update items that were actually modified
    const itemsToUpdate = this.arrayForEditPriceConfig.filter((item) =>
      this.modifiedPriceIDs.has(item.priceId)
    );

    itemsToUpdate.forEach((dataForUpdate) => {
      this.masterservice.updatePriceConfig(dataForUpdate).subscribe((res) => {
        if (res) {
          if (this.isUpdating === false) {
            this.getAllPricingConfigs();
          }
        }
      });
    });

    this.postPricingData();
    this.modifiedPriceIDs.clear();
  }

  resetdata() {
    this.selectedIds = '';
    this.deletePrices = [];
    // restore from the snapshot by cloning it so the edit buffer is independent afterwards
    this.arrayForEditPriceConfig = this.tempArray.map((item) => ({ ...item }));
    this.modifiedPriceIDs.clear();
    this.isUpdating = false;
  }

  cancelPrice(data: any, index: any) {
    this.Deptpriceconfigarray[index].price = this.lastPrice;

    this.Deptpriceconfigarray.forEach((element) => {
      if (
        element.categoryId == data.categoryId &&
        element.departmentId === data.departmentId &&
        element.pricingTypeId == data.pricingTypeId &&
        element.priceId === data.priceId
      ) {
        this.selectedRowIndex = null;
        this.editZone = true;
        this.openInput = true;
        return;
      }
    });
  }

  exportToExcel() {
    // Define the pricing type structure matching the import template
    const pricingTypeStructure: {
      [key: number]: {
        name: string;
        columns: string[];
        colWidths: any[];
      };
    } = {
      1: {
        name: 'GBB by Category and SubCategory',
        columns: ['Store Group', 'Department', 'Category', 'Sub-Category', 'Quality', 'Price'],
        colWidths: [
          { wch: 25 },
          { wch: 30 },
          { wch: 25 },
          { wch: 25 },
          { wch: 15 },
          { wch: 12 },
        ],
      },
      2: {
        name: 'Price Lists by Category and SubCategory',
        columns: ['Store Group', 'Department', 'Category', 'Sub-Category', 'Price'],
        colWidths: [
          { wch: 25 },
          { wch: 30 },
          { wch: 25 },
          { wch: 25 },
          { wch: 12 },
        ],
      },
      3: {
        name: 'Price Lists by Department',
        columns: ['Store Group', 'Department', 'Price'],
        colWidths: [{ wch: 25 }, { wch: 30 }, { wch: 12 }],
      },
      4: {
        name: 'Quality and Condition by Category and SubCategory',
        columns: ['Store Group', 'Department', 'Category', 'Sub-Category', 'Quality', 'Condition', 'Price'],
        colWidths: [
          { wch: 25 },
          { wch: 30 },
          { wch: 25 },
          { wch: 25 },
          { wch: 15 },
          { wch: 15 },
          { wch: 12 },
        ],
      },
      5: {
        name: 'GBB by Department',
        columns: ['Store Group', 'Department', 'Quality', 'Price'],
        colWidths: [{ wch: 25 }, { wch: 30 }, { wch: 15 }, { wch: 12 }],
      },
      6: {
        name: 'Quality and Condition by Department',
        columns: ['Store Group', 'Department', 'Quality', 'Condition', 'Price'],
        colWidths: [
          { wch: 25 },
          { wch: 30 },
          { wch: 15 },
          { wch: 15 },
          { wch: 12 },
        ],
      },
    };

    // Group data by pricing type
    const groupedByType: {
      [key: number]: deptpriceconfig[];
    } = {};

    this.Deptpriceconfigarray.forEach((item) => {
      const typeId = item.pricingTypeId || 3; // Default to type 3 if not set
      if (!groupedByType[typeId]) {
        groupedByType[typeId] = [];
      }
      groupedByType[typeId].push(item);
    });

    // Create workbook
    const wb = XLSX.utils.book_new();

    // Process each pricing type that has data
    Object.keys(groupedByType).forEach((typeIdStr) => {
      const typeId = parseInt(typeIdStr);
      const typeConfig = pricingTypeStructure[typeId];

      if (!typeConfig) return;

      const typeData = groupedByType[typeId];
      const sheetData: any[] = [];

      // Add header row
      sheetData.push(typeConfig.columns);

      // Add data rows
      typeData.forEach((item) => {
        const row: any = {};

        typeConfig.columns.forEach((col) => {
          switch (col) {
            case 'Store Group':
              row[col] = item.name || '';
              break;
            case 'Department':
              row[col] = item.department || '';
              break;
            case 'Category':
              row[col] = item.categoryName || '';
              break;
            case 'Sub-Category':
              row[col] = item.subCategoryName || '';
              break;
            case 'Quality':
              row[col] = item.qualityDescr || '';
              break;
            case 'Condition':
              row[col] = item.conditionDescr || '';
              break;
            case 'Price':
              row[col] = item.price || '';
              break;
            default:
              row[col] = '';
          }
        });

        sheetData.push(Object.values(row));
      });

      // Create worksheet
      const ws = XLSX.utils.aoa_to_sheet(sheetData);
      ws['!cols'] = typeConfig.colWidths;

      // Add sheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, typeConfig.name.substring(0, 31));
    });

    // Write file
    XLSX.writeFile(wb, 'Pricing_Config_Export.xlsx');
  }

  handleCheck(config: deptpriceconfig) {
    if (config.pricingTypeId != 2 && config.pricingTypeId != 3) {
      this.Deptpriceconfigarray.forEach((res) => {
        if (
          res.departmentId == config.departmentId &&
          res.categoryId == config.categoryId &&
          config.pricingTypeId == res.pricingTypeId &&
          res.storeGroupId == config.storeGroupId
        ) {
          res.isChecked = !res.isChecked;
          if (!this.deletePrices.includes(res.priceId.toString())) {
            this.deletePrices.push(res.priceId.toString());
          } else {
            this.deletePrices.splice(
              this.deletePrices.indexOf(res.priceId.toString()),
              1
            );
          }
        }
      });
    } else {
      if (!this.deletePrices.includes(config.priceId.toString())) {
        this.deletePrices.push(config.priceId.toString());
      } else {
        this.deletePrices.splice(
          this.deletePrices.indexOf(config.priceId.toString()),
          1
        );
      }
    }

    if (this.deletePrices.length > 0) {
      this.checkDel = false;
    } else {
      this.checkDel = true;
    }
  }

  getSelectedPricingForDelete(): deptpriceconfig[] {
    return this.Deptpriceconfigarray.filter(item =>
      this.deletePrices.includes(item.priceId.toString())
    );
  }

  deletePricing() {
    const selectedIds: string = this.deletePrices.join(',');

    this.masterservice.deletePricingConfig(selectedIds).subscribe((res) => {
      if (res) {
        this.Deptpriceconfigarray = this.Deptpriceconfigarray.filter(
          (item) => !selectedIds.includes(item.priceId.toString())
        );
        this.toastr.success('Prices Deleted !', 'Success');
      }
    });
  }
  delSinglePrice(i: number, data: deptpriceconfig) {
    this.deletePrices.push(data.priceId.toString());
    this.selectedIds = this.deletePrices.join(',');
    this.arrayForEditPriceConfig.splice(i, 1);
  }

  toggleCustomSelect() {
    this.isCustomSelect = !this.isCustomSelect;
  }

  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    if (!this.customSelect.nativeElement.contains(event.target)) {
      this.isCustomSelect = true;
    }
  }

  addLevel() {
    let priceobj = { ...this.priceobj };
    priceobj.price = 0;
    priceobj.priceId = 0;
    this.pricingTypeID = priceobj.pricingTypeId;
    this.prcingTypeConfigData = priceobj;

    this.arrayForEditPriceConfig.push(priceobj);
  }

  onPriceChange(priceConfig: deptpriceconfig) {
    // Track that this price config has been modified
    if (priceConfig.priceId) {
      this.modifiedPriceIDs.add(priceConfig.priceId);
    }
  }

  async postPricingData() {
    let userdata = this.masterservice.getUserDetailsFromStorage();
    let companyID = userdata.companyID;

    await this.arrayForEditPriceConfig.forEach(async (element) => {
      if (element.price > 0) {
        let qualityID = element.qualityId == undefined ? 0 : element.qualityId;
        let conditionID =
          element.conditionId == undefined ? 0 : element.conditionId;
        let priceID = element.priceId == undefined ? 0 : element.priceId;

        this.priceConfigPostDataString.push(
          `${this.pricingTypeID}|${this.prcingTypeConfigData.storeGroupId}|${qualityID}|${conditionID}|${element.price}|${this.prcingTypeConfigData.departmentId}|0|${this.prcingTypeConfigData.categoryId}|${companyID}|${userdata.userId}|${priceID}`
        );
      }
    });

    await this.masterservice
      .addupdatelistofprices(this.priceConfigPostDataString)
      .subscribe((Response) => {
        if (Response) {
          this.toastr.success('Price Updated!', 'Success');
        }
        this.priceConfigPostDataString = [];

        this.refreshPriceConfig();
      });
  }

  refreshPriceConfig() {
    let userdata = this.masterservice.getUserDetailsFromStorage();
    let c_id = userdata.companyID;
    this.masterservice.getPricingTypeConfig(c_id).subscribe((res) => {
      if (res) {
        this.DeptpriceUpdate = res as deptpriceconfig[];
        this.Deptpriceconfigarray = this.DeptpriceUpdate;
        this.Deptpriceconfigarray1 = this.DeptpriceUpdate;

        this.getFilterData();
      }
    });
  }

  async activeTab(val: boolean) {
    this.isLoading = true;

    this.Deptpriceconfigarray = [];
    this.Deptpriceconfigarray = [];
    this.Deptpriceconfigarray1 = [];
    this.DeptpriceUpdate = [];
    this.unaddedPrices = [];

    this.noData = false;
    this.isPriceActive = val;
    this.clearAllFilter();
    if (this.isPriceActive) {
      await this.getAllPricingConfigs();
    } else {
      await this.getUnaddedPrices();
    }
    this.isLoading = false;
  }

  onDepartmentToggle(departmentId: number, event: any) {
    if (event.target.checked) {
      this.departmentIDs.push(departmentId);
    } else {
      this.departmentIDs = this.departmentIDs.filter(
        (id) => id !== departmentId
      );
    }
  }

  resetPriceConfig() {
    let user = this.masterservice.getUserDetailsFromStorage();
    const companyID = user.companyID; // Replace with your actual company ID
    const deptString = this.departmentIDs.join(',');
    this.masterservice
      .resetPriceConfig(companyID, this.resetStoreID, deptString)
      .subscribe((res) => {
        if (res) {
          this.getAllPricingConfigs();
          this.departmentIDs = [];
          this.resetStoreID = 0;
          this.toastr.success('Prices Deleted!', 'Success');
        }
      });
  }

  getSelectedDepartmentNames(): string {
    const selected = this.departmentReset
      .filter((dept) => this.departmentIDs.includes(dept.departmentId))
      .map((dept) => dept.department);

    if (selected.length === 0) return '';
    if (selected.length <= 2) return selected.join(', ');

    const remaining = selected.length - 2;
    return `${selected.slice(0, 2).join(', ')} +${remaining}`;
  }

  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.readExcelFile(file);
    }
  }

  readExcelFile(file: File) {
    const reader = new FileReader();
    reader.onload = async (e: any) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        this.isImportLoading = true;

        // Process all sheets except 'Instructions'
        const allSheetData: any[] = [];

        // Known pricing type names (from mapping keys)
        const knownPricingNames = Object.keys(this.pricingTypeMapping || {});

        const normalize = (s: string) =>
          (s || '')
            .toString()
            .replace(/[^a-z0-9]/gi, '')
            .toLowerCase();

        const mapSheetName = (sheetName: string) => {
          if (!sheetName) return sheetName;
          // exact match
          const exact = knownPricingNames.find(
            (k) => k.toLowerCase() === sheetName.toLowerCase()
          );
          if (exact) return exact;

          const normSheet = normalize(sheetName);
          // try to find a known name that starts with the sheet name (truncated case) or contains it
          const prefixMatch = knownPricingNames.find(
            (k) =>
              normalize(k).startsWith(normSheet) ||
              normSheet.startsWith(
                normalize(k).slice(
                  0,
                  Math.min(normalize(k).length, normSheet.length)
                )
              )
          );
          if (prefixMatch) return prefixMatch;

          // fallback: find by inclusion
          const includeMatch = knownPricingNames.find(
            (k) =>
              normalize(k).includes(normSheet) ||
              normSheet.includes(normalize(k))
          );
          if (includeMatch) return includeMatch;

          // last resort, return original
          return sheetName;
        };

        for (const sheetName of workbook.SheetNames) {
          if (sheetName.toLowerCase() !== 'instructions') {
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

            // Map possibly-truncated sheet name to the full known pricing type name
            const fullSheetName = mapSheetName(sheetName);

            allSheetData.push({ sheetName: fullSheetName, data: jsonData });
          }
        }

        await this.parseImportData(allSheetData);
        this.openImportModal();
        this.isImportLoading = false;
      } catch (error) {
        this.isImportLoading = false;
        this.toastr.error('Error reading Excel file. Please check the format.');
        console.error('Excel read error:', error);
      }
    };
    reader.readAsArrayBuffer(file);
  }

  async parseImportData(allSheetData: any[]) {
    this.importData = [];
    this.importErrors = [];
    this.validImportRows = 0;

    // Process each sheet
    for (const sheetInfo of allSheetData) {
      const data = sheetInfo.data;
      const sheetName = sheetInfo.sheetName;

      if (!data || data.length === 0) continue;

      // Skip header row
      const headers = data[0];

      // Get column indices
      const getColIndex = (colName: string) => headers.indexOf(colName);

      // Find where the actual data starts (after example data and before instructions)
      let dataStartIndex = 1;
      let instructionsStartIndex = data.length;
      let foundInstructions = false;

      for (let i = 1; i < data.length; i++) {
        const row = data[i];

        // Check if we've hit the instructions section
        if (row && row[0]) {
          const firstCell = row[0].toString().trim();
          if (
            firstCell.includes('===') ||
            firstCell.toLowerCase().includes('instructions') ||
            firstCell.toLowerCase().includes('requirements') ||
            firstCell.toLowerCase().includes('important') ||
            firstCell.toLowerCase().includes('how to use') ||
            firstCell.toLowerCase().includes('pricing type')
          ) {
            instructionsStartIndex = i;
            foundInstructions = true;
            break;
          }
        }

        // Skip empty rows
        if (!row || row.length === 0 || !row[0]) {
          continue;
        }
      }

      // Process only the data rows (between header and instructions)
      for (let i = dataStartIndex; i < instructionsStartIndex; i++) {
        const row = data[i];

        // Skip completely empty rows
        if (!row || row.length === 0) continue;

        // Skip rows that are part of instruction sections
        if (row[0]) {
          const firstCell = row[0].toString().trim();
          if (
            firstCell.includes('===') ||
            firstCell.toLowerCase().includes('instructions') ||
            firstCell.toLowerCase().includes('requirements') ||
            firstCell.toLowerCase().includes('important') ||
            firstCell.toLowerCase().includes('how to use') ||
            firstCell.toLowerCase().includes('pricing type') ||
            firstCell.toLowerCase().includes('example') ||
            (firstCell === '' && (!row[1] || row[1].toString().trim() === ''))
          ) {
            continue;
          }
        }

        // Get store group from first column
        const storeGroupValue =
          row[getColIndex('Store Group')]?.toString().trim() || '';
        if (!storeGroupValue) continue;

        // Determine pricing type based on sheet name
        let priceType = sheetName;

        const rowData = {
          storeGroup: storeGroupValue,
          department: row[getColIndex('Department')]?.toString().trim() || '',
          category: row[getColIndex('Category')]?.toString().trim() || '',
          subCategory:
            row[getColIndex('Sub-Category')]?.toString().trim() || '',
          priceType: priceType,
          quality: row[getColIndex('Quality')]?.toString().trim() || '',
          condition: row[getColIndex('Condition')]?.toString().trim() || '',
          price: this.parsePrice(row[getColIndex('Price')]),
          rowNumber: i + 1,
          sheetName: sheetName,
          valid: true,
          errors: [] as string[],
        };

        // Validate row
        await this.validateImportRow(rowData);

        if (rowData.valid) {
          this.validImportRows++;
        }

        this.importData.push(rowData);
      }
    }

    // Create preview (show all imported rows)
    // Use a shallow copy so UI bindings operate on a separate array
    this.importPreview = this.importData.slice();

    // Check for duplicate Store + Department combinations across all sheets
    this.detectDuplicateDepartmentsAcrossSheets();
  }

  detectDuplicateDepartmentsAcrossSheets() {
    // Track Store + Department combinations and which sheets they appear in
    const storeDeptMap = new Map<string, { sheetRows: Map<string, any[]> }>();

    // Only check valid rows
    const validRows = this.importData.filter((row) => row.valid);

    for (const row of validRows) {
      const key = `${row.storeGroup}|${row.department}`;

      if (!storeDeptMap.has(key)) {
        storeDeptMap.set(key, { sheetRows: new Map<string, any[]>() });
      }

      const entry = storeDeptMap.get(key)!;

      // Group rows by sheet name
      if (!entry.sheetRows.has(row.sheetName)) {
        entry.sheetRows.set(row.sheetName, []);
      }

      entry.sheetRows.get(row.sheetName)!.push(row);
    }

    // Find duplicates (Store + Department appearing in multiple sheets)
    const duplicates: any[] = [];

    for (const [key, entry] of storeDeptMap.entries()) {
      const sheets = Array.from(entry.sheetRows.keys());

      if (sheets.length > 1) {
        // This Store + Department combination appears in multiple sheets
        const [storeGroup, department] = key.split('|');
        duplicates.push({
          storeGroup,
          department,
          sheets: sheets,
          sheetRows: entry.sheetRows,
        });
      }
    }

    // Mark duplicate rows as invalid and add error messages
    if (duplicates.length > 0) {
      for (const duplicate of duplicates) {
        const sheetsText = duplicate.sheets.join(', ');
        const errorMsg = `Duplicate: Store "${duplicate.storeGroup}" + Department "${duplicate.department}" appears in multiple sheets: ${sheetsText}. Each Store + Department combination should only appear in ONE sheet.`;

        // Keep ALL rows from the first sheet valid
        // Mark ALL rows from other sheets as invalid
        const firstSheet = duplicate.sheets[0]; // First sheet in the list

        for (const [sheetName, rows] of duplicate.sheetRows.entries()) {
          if (sheetName === firstSheet) {
            // Keep all rows from the first sheet valid (no changes)
            continue;
          } else {
            // Mark all rows from other sheets as invalid
            for (const row of rows) {
              row.valid = false;
              row.errors.push(errorMsg);
              this.validImportRows--;
            }
          }
        }

        // Add to import errors for display
        this.importErrors.push(errorMsg);
      }

      // Update the preview to reflect the validation changes
      this.importPreview = this.importData.slice();
    }
  }

  parsePrice(value: any): number {
    if (value === null || value === undefined || value === '') return 0;

    // Remove currency symbols and commas
    const cleanValue = value.toString().replace(/[$,]/g, '').trim();
    const parsed = parseFloat(cleanValue);

    return isNaN(parsed) ? 0 : parsed;
  }

  async validateImportRow(row: any): Promise<void> {
    // Validate Store Group
    const storeGroup = this.storeGroups.find(
      (sg) =>
        (sg.name || '').toLowerCase().trim() ===
        (row.storeGroup || '').toLowerCase().trim()
    );
    if (!storeGroup) {
      row.errors.push(`Store Group '${row.storeGroup}' not found`);
      row.valid = false;
      return; // Early return if store group not found
    }
    row.storeGroupId = storeGroup.id;

    // Validate Department
    const department = this.departmentslist.find(
      (d) =>
        (d.departmentDescr || '').toLowerCase().trim() ===
        (row.department || '').toLowerCase().trim()
    );
    if (!department) {
      row.errors.push(`Department '${row.department}' not found/Inactive`);
      row.valid = false;
      return; // Early return if department not found
    }
    row.departmentId = department.departmentId;

    // Validate Price Type
    const pricingTypeID = this.pricingTypeMapping[row.priceType];
    if (!pricingTypeID) {
      row.errors.push(
        `Invalid Price Type '${row.priceType}'. Valid types: ${Object.keys(
          this.pricingTypeMapping
        ).join(', ')}`
      );
      row.valid = false;
      return;
    }
    row.pricingTypeID = pricingTypeID;

    // Validate price
    if (row.price <= 0) {
      row.errors.push('Price must be greater than 0');
      row.valid = false;
    }

    // Get validation data from API
    const validationData = await this.getValidationData(
      storeGroup.id,
      department.departmentId,
      pricingTypeID
    );

    if (!validationData) {
      row.errors.push('Unable to validate pricing configuration');
      row.valid = false;
      return;
    }

    // Validate based on pricing type requirements
    const requiresQuality = [1, 4, 5, 6].includes(pricingTypeID);
    const requiresCondition = [4, 6].includes(pricingTypeID);
    const requiresCategory = [1, 2, 4].includes(pricingTypeID);

    // Validate Quality
    if (requiresQuality) {
      if (!row.quality) {
        row.errors.push('Quality is required for this pricing type');
        row.valid = false;
      } else {
        const quality = validationData.pricingData.find(
          (q: any) =>
            (q.qualitydescr || q.qualityDescr || q.QualityDescr || '')
              .toLowerCase()
              .trim() === row.quality.toLowerCase().trim()
        );
        if (!quality) {
          const availableQualities = validationData.pricingData
            .map((q: any) => q.qualitydescr || q.qualityDescr || q.QualityDescr)
            .filter((q: any) => q)
            .join(', ');
          row.errors.push(
            `Quality '${row.quality}' not found. Available: ${availableQualities}`
          );
          row.valid = false;
        } else {
          row.qualityID =
            quality.qualityID ||
            quality.QualityID ||
            quality.QualityId ||
            quality.qualityId;
        }
      }
    }

    // Validate Condition
    if (requiresCondition) {
      if (!row.condition) {
        row.errors.push('Condition is required for this pricing type');
        row.valid = false;
      } else {
        // For condition validation, we need to get conditions from your system
        // Assuming you have getCondition array populated
        const condition = this.conditions.find(
          (c) =>
            (c.conditionDescr || '').toLowerCase().trim() ===
            (row.condition || '').toLowerCase().trim()
        );
        if (!condition) {
          row.errors.push(`Condition '${row.condition}' not found`);
          row.valid = false;
        } else {
          row.conditionID = condition.conditionId;
        }
      }
    }

    // Validate Category
    if (requiresCategory) {
      if (!row.category) {
        row.errors.push('Category is required for this pricing type');
        row.valid = false;
      } else {
        // normalization helper to handle punctuation, multiple spaces and diacritics
        const normalize = (s: any) => {
          if (s === null || s === undefined) return '';
          try {
            return s
              .toString()
              .normalize('NFKD')
              .replace(/\p{Diacritic}/gu, '')
              .replace(/[^a-z0-9]/gi, '')
              .toLowerCase()
              .trim();
          } catch (e) {
            // fallback for environments without full unicode support
            return s
              .toString()
              .replace(/[^a-z0-9]/gi, '')
              .toLowerCase()
              .trim();
          }
        };

        const rawCategory = (row.category || '').toString().trim();

        let category = validationData.categoryData.find((c: any) => {
          // Try multiple possible property names for category name
          const categoryName =
            c.CategoryName ||
            c.categoryName ||
            c.name ||
            c.Category ||
            c.category ||
            '';
          return (
            categoryName.toLowerCase().trim() ===
            rawCategory.toLowerCase().trim()
          );
        });

        // try normalized exact match
        if (!category) {
          const nRow = normalize(rawCategory);

          category = validationData.categoryData.find((c: any) => {
            const categoryName =
              c.CategoryName ||
              c.categoryName ||
              c.name ||
              c.Category ||
              c.category ||
              '';
            const nc = normalize(categoryName);
            return nc === nRow;
          });
        }

        // try inclusion/startsWith fallback ONLY as last resort
        if (!category) {
          const nRow = normalize(rawCategory);

          // VERY STRICT: Only match if it's a SUBSTRING of length >= 4 chars, not just any overlap
          // This prevents "Bibs" from matching "T-Shirt" - they have NO common substring
          category = validationData.categoryData.find((c: any) => {
            const categoryName =
              c.CategoryName ||
              c.categoryName ||
              c.name ||
              c.Category ||
              c.category ||
              '';
            const nc = normalize(categoryName);

            // Must have a continuous substring of at least 4 characters, OR one must fully contain the other
            let bestMatchLength = 0;

            // Check if one is a complete substring of the other
            if (nc.includes(nRow) && nRow.length >= 4) {
              bestMatchLength = nRow.length;
            } else if (nRow.includes(nc) && nc.length >= 4) {
              bestMatchLength = nc.length;
            } else {
              // Find longest common substring (simplified: consecutive chars)
              for (
                let len = Math.min(nc.length, nRow.length);
                len >= 4;
                len--
              ) {
                for (let i = 0; i <= nc.length - len; i++) {
                  if (nRow.includes(nc.substring(i, i + len))) {
                    bestMatchLength = Math.max(bestMatchLength, len);
                  }
                }
              }
            }

            return bestMatchLength >= 4;
          });
        }

        if (!category) {
          const availableCategories = (validationData.categoryData || [])
            .map(
              (c: any) =>
                c.CategoryName ||
                c.categoryName ||
                c.name ||
                c.Category ||
                c.category ||
                ''
            )
            .filter((v: any) => v)
            .join(', ');
          row.errors.push(
            `Category '${row.category}' not found/Inactive. Available: ${availableCategories}`
          );
          row.valid = false;
        } else {
          // Try multiple possible property names for category ID
          row.categoryId =
            category.CategoryID ||
            category.categoryId ||
            category.catId ||
            category.Id ||
            category.id ||
            0;

          // Validate Sub-Category if provided
          if (row.subCategory) {
            const rawSub = (row.subCategory || '').toString().trim();

            // candidate name fields in subCategory records
            const subNameFields = [
              'categoryName',
              'CategoryName',
              'SubCategoryName',
              'SubCategory',
              'SubCategoryDescr',
              'SubCategoryDesc',
              'Name',
              'subCategoryName',
              'subCategory'
            ];

            const findSubByField = (
              field: string,
              cmp: (val: string) => boolean
            ) => {
              return validationData.subCategoryData.find(
                (sc: any) =>
                  (sc.CategoryID || sc.categoryId || sc.catId) ==
                  row.categoryId && cmp((sc[field] || '').toString())
              );
            };

            let subCategory: any = null;

            // 1) exact case-insensitive match across candidate fields
            for (const f of subNameFields) {
              if (subCategory) break;
              subCategory = findSubByField(
                f,
                (val) =>
                  val.toLowerCase().trim() === rawSub.toLowerCase().trim()
              );
            }

            // 2) normalized exact match
            if (!subCategory) {
              const nSub = normalize(rawSub);
              for (const f of subNameFields) {
                if (subCategory) break;
                subCategory = findSubByField(
                  f,
                  (val) => normalize(val) === nSub
                );
              }
            }

            // 3) inclusion/startsWith fallback
            if (!subCategory) {
              const nSub = normalize(rawSub);
              for (const f of subNameFields) {
                if (subCategory) break;
                subCategory = findSubByField(f, (val) => {
                  const nv = normalize(val);
                  return (
                    nv.includes(nSub) ||
                    nSub.includes(nv) ||
                    nv.startsWith(nSub) ||
                    nSub.startsWith(nv)
                  );
                });
              }
            }

            if (!subCategory) {

              const availableSubCategories = (
                validationData.subCategoryData || []
              )
                .filter(
                  (sc: any) =>
                    (sc.CategoryID || sc.categoryId || sc.catId) ==
                    row.categoryId
                )
                .map((sc: any) => {
                  for (const f of subNameFields) {
                    if (sc[f]) return sc[f];
                  }
                  return sc.CategoryName || '';
                })
                .filter((v: any) => v)
                .join(', ');
              row.errors.push(
                `Sub-Category '${row.subCategory}' not found for category '${row.category
                }'. Available: ${availableSubCategories || 'None'}`
              );
              row.valid = false;
            } else {
              row.subCategoryID =
                subCategory.SubCategoryID ||
                subCategory.SubCategoryId ||
                subCategory.subCategoryId ||
                subCategory.Id ||
                subCategory.id ||
                0;
            }
          } else {
            // Build cleaned list of available subcategory names for this category
            const subNameFields = [
              'CategoryName',
              'SubCategoryName',
              'SubCategory',
              'SubCategoryDescr',
              'SubCategoryDesc',
              'Name',
            ];

            const availableSubCategoriesArr = (
              validationData.subCategoryData || []
            )
              .filter(
                (sc: any) =>
                  (sc.CategoryID || sc.categoryId || sc.catId) == row.categoryId
              )
              .map((sc: any) => {
                for (const f of subNameFields) {
                  if (sc[f]) return sc[f];
                }
                return sc.CategoryName || '';
              })
              .map((v: any) => (v || '').toString().trim())
              .filter((v: any) => v.length > 0);

            const availableSubCategories = availableSubCategoriesArr.join(', ');
            if (availableSubCategoriesArr.length > 0) {
              row.errors.push(
                `Sub-Category 'Available: ${availableSubCategories || 'None'
                } for category '${row.category}' is required`
              );
              row.valid = false;
            }
            row.subCategoryID = 0;
          }
        }
      }
    } else {
      row.categoryId = 0;
      row.subCategoryID = 0;
    }

    // Set defaults for non-required fields
    if (!requiresQuality) row.qualityID = 0;
    if (!requiresCondition) row.conditionID = 0;
  }

  async getValidationData(
    storeGroupId: number,
    departmentId: number,
    pricingTypeID: number
  ): Promise<any> {
    const cacheKey = `${storeGroupId}-${departmentId}-${pricingTypeID}`;

    // Check cache first
    if (this.validationCache.has(cacheKey)) {
      const cachedData = this.validationCache.get(cacheKey);
      return cachedData;
    }

    try {
      const userdata = this.masterservice.getUserDetailsFromStorage();
      const companyID = userdata.companyID;

      const data: any = await this.masterservice
        .getPriceConfigTemplate(
          companyID,
          pricingTypeID,
          departmentId,
          storeGroupId
        )
        .toPromise();

      // Cache the result
      this.validationCache.set(cacheKey, data);
      return data;
    } catch (error) {
      console.error('Error fetching validation data:', error);
      return null;
    }
  }

  openImportModal() {
    this.importModal.nativeElement.click();
  }

  async processImport() {
    this.isImporting = true;
    const validRows = this.importData.filter((row) => row.valid);

    let successCount = 0;
    let failCount = 0;

    try {
      // Group rows by store group + department + pricing type
      const groupedRows = this.groupImportRows(validRows);

      const groupedArray = Object.keys(groupedRows).map((key) => {
        const [storeGroupId, departmentId, pricingTypeID] = key
          .split('-')
          .map(Number);
        return {
          storeGroupId,
          departmentId,
          pricingTypeID,
          items: groupedRows[key],
        };
      });

      // const duplicateGroups = groupedArray.filter((group) =>
      //   this.pricingConfig.some(
      //     (config) =>
      //       Number(config.storeGroupId) === Number(group.storeGroupId) &&
      //       Number(config.departmentId) === Number(group.departmentId)
      //   )
      // );

      // if (duplicateGroups.length > 0) {
      //   const duplicateMsg = duplicateGroups
      //     .map(
      //       (d) =>
      //         `Dept: ${d.items[0].department}, Store: ${d.items[0].storeGroup}, Type: ${d.items[0].priceType}`
      //     )
      //     .join('\n');

      //   this.toastr.warning(
      //     `Import skipped. This Store + Department combination already exists with a different pricing type:\n${duplicateMsg}`,
      //     'Duplicate Found'
      //   );

      //   this.importErrors.push(
      //     'Import skipped. The following Store + Department combinations already exist in the system (with different pricing types):'
      //   );
      //   duplicateGroups.forEach((d) => {
      //     this.importErrors.push(duplicateMsg);
      //   });
      //   this.importErrors.push(
      //     'Each Store + Department can only have ONE pricing configuration. Please delete/reset the existing data before importing with a different pricing type.'
      //   );

      //   this.isImporting = false;
      //   return;
      // }

      // Diagnostic: check for rows that might be missing category/subcategory when required
      const requiresCategorySet = new Set([1, 2, 4]);

      for (const [key, rows] of Object.entries(groupedRows)) {
        // Log any suspicious rows into importErrors so they show in the UI preview
        for (const r of rows) {
          if (
            requiresCategorySet.has(r.pricingTypeID) &&
            (!r.categoryId || r.categoryId === 0)
          ) {
            this.importErrors.push(
              `Row ${r.rowNumber} (sheet ${r.sheetName}): pricing type requires category but categoryId=0 for Department='${r.department}', Store='${r.storeGroup}', Category='${r.category}', Sub='${r.subCategory}'`
            );
          }
        }

        try {
          await this.importRowGroup(rows);
          successCount += rows.length;
        } catch (error) {
          failCount += rows.length;
          console.error(`Error importing group ${key}:`, error);
        }
      }
    } catch (error) {
      console.error('Error during import:', error);
    }

    this.isImporting = false;

    if (successCount > 0) {
      this.toastr.success(
        `Successfully imported ${successCount} pricing records`
      );
      this.cancelImport();

      if (this.importModalClose && this.importModalClose.nativeElement) {
        this.importModalClose.nativeElement.click();
      }

      await this.getAllPricingConfigs();
    }

    if (failCount > 0) {
      this.toastr.error(`Failed to import ${failCount} records`);
    }
  }

  groupImportRows(rows: any[]): { [key: string]: any[] } {
    const groups: { [key: string]: any[] } = {};

    for (const row of rows) {
      const key = `${row.storeGroupId}-${row.departmentId}-${row.pricingTypeID}`;
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(row);
    }

    return groups;
  }

  async importRowGroup(rows: any[]): Promise<void> {
    const userdata = this.masterservice.getUserDetailsFromStorage();
    const companyID = userdata.companyID;
    const userId = userdata.userId;

    const priceConfigStrings: string[] = [];

    for (const row of rows) {
      // Format: pricingTypeID|storeGroupId|qualityID|conditionID|price|departmentId|subCategoryID|categoryId|companyID|userId|priceID
      const priceConfigString = `${row.pricingTypeID}|${row.storeGroupId}|${row.qualityID || 0
        }|${row.conditionID || 0}|${row.price}|${row.departmentId}|${row.subCategoryID || 0
        }|${row.categoryId || 0}|${companyID}|${userId}|0`;
      priceConfigStrings.push(priceConfigString);
    }

    await this.masterservice
      .addupdatelistofprices(priceConfigStrings, true)
      .toPromise();
  }

  cancelImport() {
    this.importData = [];
    this.importPreview = [];
    this.importErrors = [];
    this.validImportRows = 0;
    this.validationCache.clear();
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }

  downloadTemplate() {
    // Define pricing types with their requirements
    const pricingTypes = [
      {
        name: 'Price Lists by Department',
        id: 1,
        columns: ['Store Group', 'Department', 'Price'],
        examples: [
          ['Example Store 2', 'Furniture', '199.99'],
          ['Example Store 2', 'Furniture', '299.99'],
          ['Example Store 3', 'Furniture', '399.99'],
        ],
        requirements:
          'Required: Store Group, Department, Price | Note: Add multiple rows for different price levels',
      },
      {
        name: 'GBB by Department',
        id: 2,
        columns: ['Store Group', 'Department', 'Quality', 'Price'],
        examples: [
          ['Example Store 3', 'Books', 'Good', '15.99'],
          ['Example Store 3', 'Books', 'Better', '25.99'],
          ['Example Store 3', 'Books', 'Best', '35.99'],
        ],
        requirements: 'Required: Store Group, Department, Quality, Price',
      },
      {
        name: 'Quality and Condition by Department',
        id: 3,
        columns: ['Store Group', 'Department', 'Quality', 'Condition', 'Price'],
        examples: [
          ['Example Store 4', 'Electronics', 'Good', 'New', '149.99'],
          ['Example Store 4', 'Electronics', 'Good', 'Used', '99.99'],
          ['Example Store 4', 'Electronics', 'Better', 'New', '199.99'],
        ],
        requirements:
          'Required: Store Group, Department, Quality, Condition, Price',
      },
      {
        name: 'Price Lists by Category and SubCategory',
        id: 4,
        columns: [
          'Store Group',
          'Department',
          'Category',
          'Sub-Category',
          'Price',
        ],
        examples: [
          [
            'Example Store 1',
            'Electronics',
            'Laptops',
            'Gaming Laptops',
            '999.99',
          ],
          [
            'Example Store 1',
            'Electronics',
            'Laptops',
            'Business Laptops',
            '1299.99',
          ],
          ['Example Store 1', 'Electronics', 'Laptops', '', '1599.99'],
        ],
        requirements:
          'Required: Store Group, Department, Category, Price | Optional: Sub-Category | Note: Add multiple rows for different price levels',
      },
      {
        name: 'GBB by Category and SubCategory',
        id: 5,
        columns: [
          'Store Group',
          'Department',
          'Category',
          'Sub-Category',
          'Quality',
          'Price',
        ],
        examples: [
          [
            'Example Store 1',
            'Electronics',
            'Laptops',
            'Gaming Laptops',
            'Good',
            '999.99',
          ],
          [
            'Example Store 1',
            'Electronics',
            'Laptops',
            'Business Laptops',
            'Better',
            '1299.99',
          ],
          ['Example Store 1', 'Electronics', 'Laptops', '', 'Best', '1599.99'],
        ],
        requirements:
          'Required: Store Group, Department, Category, Quality, Price | Optional: Sub-Category',
      },
      {
        name: 'Quality and Condition by Category and SubCategory',
        id: 6,
        columns: [
          'Store Group',
          'Department',
          'Category',
          'Sub-Category',
          'Quality',
          'Condition',
          'Price',
        ],
        examples: [
          ['Example Store 2', 'Clothing', 'Shirts', '', 'Good', 'New', '29.99'],
          [
            'Example Store 2',
            'Clothing',
            'Shirts',
            '',
            'Good',
            'Used',
            '19.99',
          ],
          [
            'Example Store 2',
            'Clothing',
            'Shirts',
            '',
            'Better',
            'New',
            '39.99',
          ],
        ],
        requirements:
          'Required: Store Group, Department, Category, Quality, Condition, Price | Optional: Sub-Category',
      },
    ];

    const wb = XLSX.utils.book_new();

    // Create a summary/instructions sheet FIRST
    const summaryData = [
      ['PRICING IMPORT TEMPLATE - INSTRUCTIONS'],
      [],
      ['This workbook contains separate sheets for each pricing type.'],
      [
        'Please use the appropriate sheet based on the pricing type you want to import.',
      ],
      [],
      ['PRICING TYPES AVAILABLE:'],
      [
        '1. GBB by Category and SubCategory - Pricing based on category/subcategory with quality levels',
      ],
      [
        '2. Price Lists by Category and SubCategory - Multiple price levels by category/subcategory',
      ],
      [
        '3. Price Lists by Department - Multiple price levels by department only',
      ],
      [
        '4. Quality and Condition by Category and SubCategory - Pricing based on category with quality and condition',
      ],
      ['5. GBB by Department - Pricing by department with quality levels'],
      [
        '6. Quality and Condition by Department - Pricing by department with quality and condition',
      ],
      [],
      ['HOW TO USE:'],
      ['1. Select the sheet corresponding to your pricing type'],
      ['2. Fill in your data starting from row 2 (row 1 contains headers)'],
      [
        '3. Keep the example rows as reference, or delete them before importing',
      ],
      ['4. Do NOT modify the column headers'],
      ['5. Ensure all required fields are populated'],
      [
        '6. Save the file and import through the pricing configuration interface',
      ],
      [],
      ['GENERAL NOTES:'],
      [
        '- Store Group, Department, Quality, and Condition must exist in your system',
      ],
      ['- Category and Sub-Category must belong to the selected Department'],
      ['- Prices must be positive numbers (decimals allowed)'],
      ['- Each row represents one pricing entry'],
      ['- Delete instruction rows before importing'],
    ];

    const summarySh = XLSX.utils.aoa_to_sheet(summaryData);
    summarySh['!cols'] = [{ wch: 80 }];
    XLSX.utils.book_append_sheet(wb, summarySh, 'Instructions');

    // Create a sheet for each pricing type
    pricingTypes.forEach((pricingType) => {
      const templateData: any[] = [];

      // Add header row
      templateData.push(pricingType.columns);

      // Add example rows
      templateData.push(...pricingType.examples);

      // Add spacing
      templateData.push([]);
      templateData.push([]);

      // Add instructions section
      templateData.push(['=== INSTRUCTIONS ===']);
      templateData.push([]);
      templateData.push(['REQUIREMENTS:']);
      templateData.push([pricingType.requirements]);
      templateData.push([]);
      templateData.push(['IMPORTANT NOTES:']);
      templateData.push([
        '1. Store Group and Department must match exactly with your system data',
      ]);
      templateData.push([
        '2. Category and Sub-Category must exist in the selected Department',
      ]);
      templateData.push([
        '3. Quality and Condition (if applicable) must match your system data',
      ]);
      templateData.push([
        '4. Price must be a positive number (decimals allowed)',
      ]);
      templateData.push(['5. Leave optional fields blank if not needed']);
      templateData.push(['6. Each row represents a single pricing entry']);

      const ws = XLSX.utils.aoa_to_sheet(templateData);

      // Set column widths based on pricing type
      const colWidths = pricingType.columns.map((col) => {
        switch (col) {
          case 'Store Group':
            return { wch: 25 };
          case 'Department':
            return { wch: 30 };
          case 'Category':
            return { wch: 25 };
          case 'Sub-Category':
            return { wch: 25 };
          case 'Quality':
            return { wch: 15 };
          case 'Condition':
            return { wch: 15 };
          case 'Price':
            return { wch: 12 };
          default:
            return { wch: 20 };
        }
      });

      ws['!cols'] = colWidths;

      // Add sheet to workbook with pricing type as sheet name
      XLSX.utils.book_append_sheet(wb, ws, pricingType.name.substring(0, 31));
    });

    XLSX.writeFile(wb, 'Pricing_Import_Template.xlsx');
  }

  getAllConditions(): void {
    const userdata = this.masterservice.getUserDetailsFromStorage();
    const companyId = userdata.companyID;

    this.masterservice.getAllConditions(companyId).subscribe((res) => {
      if (res) {
        this.conditions = res as Conditions[];
      }
    });
  }

  checkID() {
    if (this.resetStoreID > 0) {
      this.departmentReset = this.Deptpriceconfigarray1.filter(
        (item) => item.storeGroupId == this.resetStoreID
      ).reduce((accumulator: any, current) => {
        if (
          !accumulator.some(
            (item: any) => item.departmentId === current.departmentId
          )
        ) {
          accumulator.push({
            departmentId: current.departmentId,
            department: current.department,
          });
        }
        return accumulator;
      }, []);
    } else {
      this.departmentReset = [];
    }
  }
}
